export default __webpack_public_path__ + "static/media/Conscript's Belt of the Golden Sun.4f0ee57e.jpg";